/**
 * ActionToolbox - displays a palette of available action types
 *
 * @author    Claude / contexagon GmbH
 */

import React from 'react';
import { ACTION_TYPES, getStartColor, getStartBorderColor } from './actionTypes';


function ActionToolbox() {
    return (
        <div style={{ padding: '12px 8px', borderTop: '1px solid #eee' }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: '#999', textTransform: 'uppercase', marginBottom: 8, letterSpacing: 1 }}>
                Aktionstypen
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                {ACTION_TYPES.map(t => (
                    <div
                        key={t.id}
                        title={t.label}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 4,
                            padding: '3px 6px',
                            borderRadius: 3,
                            backgroundColor: '#f5f5f5',
                            fontSize: 12,
                            cursor: 'default',
                            userSelect: 'none',
                        }}
                    >
                        <span>{t.icon}</span>
                        <span style={{ color: '#555' }}>{t.label}</span>
                    </div>
                ))}
            </div>
            <div style={{ marginTop: 12, fontSize: 11, color: '#bbb' }}>
                Legende Startzeitpunkt:
            </div>
            <div style={{ marginTop: 6, display: 'flex', flexDirection: 'column', gap: 4 }}>
                {[
                    { start: 'initially', label: 'Start (t=0)' },
                    { start: 'withprevious', label: 'Parallel (gleiche Zeit)' },
                    { start: 'afterprevious', label: 'Danach (sequenziell)' },
                ].map(({ start, label }) => (
                    <div key={start} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <div style={{
                            width: 12,
                            height: 12,
                            borderRadius: 2,
                            backgroundColor: getStartColor(start),
                            borderLeft: '3px solid ' + getStartBorderColor(start),
                            flexShrink: 0,
                        }} />
                        <span style={{ fontSize: 11, color: '#666' }}>{label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ActionToolbox;
